/**
 * Agence'O - filters-trigger
 * @author Axel Baron (Agence'O)
 * @created 14/05/2019
 */

(function ($) {

  /**
   * Action for small filters bar
   */
  $(document).on('click', '.js-filters-open', (e) => {
    e.preventDefault();
    e.stopPropagation();
    let parent = $(e.currentTarget).parents('.filters').eq(0);
    let content = $(parent).find('.filters__content');
    parent.addClass('open');
    $('body').addClass('no-scroll');

    $(e.currentTarget).hide();
    parent.find('.filters__close').show();
  });

  $(document).on('click', '.js-filters-hide', (e) => {
    e.preventDefault();
    e.stopPropagation();
    let parent = $(e.currentTarget).parents('.filters').eq(0);
    let content = $(parent).find('.filters__content');
    parent.removeClass('open');
    content.slideUp();
    $(e.currentTarget).hide();
    parent.find('.filters__open').show();
    $('body').removeClass('no-scroll');
  });


  /**
   * Action for large filters column
   */
  $(".js-clear-filter").on('click', (e) => {
    e.preventDefault();
    const $this = $(e.currentTarget);
    const target = $this.data('filter');

    $(target).find('input').not(':checkbox, :radio').val('').keyup();
    $(target).find(':checkbox, :radio').prop('checked', false);
    $(target).find('.fake-select__check-number i').text('0');
  });

  $(".js-clear-filter-date").on('click', (e) => {
    e.preventDefault();
    const $this = $(e.currentTarget);
    const target = $this.data('filter');

    $(target).find('input').val('');
  });



    $(document).on('click', '#sort-filter .fake-select__content .fake-select__item', (e) => {




      e.preventDefault();
      e.stopPropagation();

      console.log($(e.currentTarget).html());
      console.log($(e.currentTarget).data('sort'));
      $('#sort-input').val($(e.currentTarget).data('sort'));

      $('#sort-filter').find('.fake-select__content').slideToggle("fast");
      $('#sort-filter').toggleClass('open');

      //$('#form-search-news').submit();



      /*
      $( "form" ).on( "submit", function( event ) {
        event.preventDefault();
        console.log( $( this ).serialize() );
      });
*/
      /*
      let parent = $(e.currentTarget).parents('.filters').eq(0);
      let content = $(parent).find('.filters__content');
      parent.removeClass('open');
      content.slideUp();
      $(e.currentTarget).hide();
      parent.find('.filters__open').show();
      $('body').removeClass('no-scroll');*/
});



}(jQuery));
